import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const FOR_SALE_METRICS = [
  {
    metricId: '1',
    displayName: 'Total Auction Listings (12 months)',
    definition:
      'The total number of auction listings that have been observed over the past year within the geography.',
    isAvailableInAU: true,
    isAvailableInNZ: true,
  },
  {
    metricId: '34',
    displayName: 'Change in Listings (monthly)',
    definition:
      'The percentage change in listings within the specified region in the current period compared to the same period 1 month ago. The result is expressed as a percentage.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '36',
    displayName: 'Total New Listings (12 months)',
    definition:
      'The total number of new listings recorded across the Geography over the past year.',
    isAvailableInAU: true,
    isAvailableInNZ: true,
  },
  {
    metricId: '44',
    displayName: 'Change in Listings (3 months)',
    definition:
      'The percentage change in listings within the specified region in the current period compared to the same period 3 months ago. The result is expressed as a percentage.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '58',
    displayName: '% Stock on Market (12 months)',
    definition:
      'The percentage of dwellings within the suburb that have been listed for sale over the past year.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
  {
    metricId: '64',
    displayName: 'Total Listings (12 months)',
    definition:
      'The total unique number of properties that have been advertised for sale and captured by Cotality over the past year. To be included in the count, the listings have to be matched to an actual address.',
    isAvailableInAU: true,
    isAvailableInNZ: true,
  },
  {
    metricId: '65',
    displayName: 'Total Listings (monthly)',
    definition:
      'The total unique number of properties that have been advertised for sale and captured by Cotality over the past month. To be included in the count, the listings have to be matched to an actual address.',
    isAvailableInAU: true,
    isAvailableInNZ: true,
  },
  {
    metricId: '70',
    displayName: 'Change in Listings (12 months)',
    definition:
      'The percentage change in listings within the specified region in the current period compared to the same period 12 months ago. The result is expressed as a percentage.',
    isAvailableInAU: true,
    isAvailableInNZ: false,
  },
];

export const ForSaleMetrics = () => {
  const country = useRootStore(state => state.country);

  return (
    <>
      <Typography id="for-sale-metrics" variant="h6" fontWeight={600} my={0.5}>
        For Sale Metrics
      </Typography>

      <Typography variant="body2">
        The For Sale metrics provide statistics based off property's for sale
        advertisement campaigns.
      </Typography>

      <br />

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ whiteSpace: 'nowrap' }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Display Name</TableCell>
              <TableCell>Definition</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {FOR_SALE_METRICS.filter(metric =>
              country === 'au'
                ? metric.isAvailableInAU
                : metric.isAvailableInNZ,
            ).map(metric => (
              <TableRow>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.metricId}
                </TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                  {metric.displayName}
                </TableCell>
                <TableCell
                  dangerouslySetInnerHTML={{ __html: metric.definition }}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
